//* Imports
import { useContext } from "react";
import { CountriesContext } from "../../App";
import { Link } from "react-router-dom";

//* Search JSX
function Search() {
  const { onSelect } = useContext(CountriesContext);

  return (
    <ul className="flex flex-wrap items-center justify-center gap-2 lg:flex-col">
      <li>
        <Link
          to="/"
          onClick={() => {
            onSelect("all");
          }}
          type="button"
          className="inline-flex items-center gap-3 px-1 py-1 mb-0 text-sm font-medium text-center text-gray-900 rounded-lg lg:mb-2 bg-translate hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-100 lg:px-3 lg:py-3 dark:focus:ring-gray-600 dark:text-white dark:hover:bg-gray-700"
        >
          <svg
            width="35px"
            height="35px"
            viewBox="0 0 52 52"
            fill="#e3567d"
            x="0px"
            y="0px"
            enableBackground="new 0 0 52 52"
          >
            <path
              d="M31.6,21.6c-1.2,0-2.2-1-2.2-2.2V5.5c0-1.2,1-2.2,2.2-2.2h14.2c1.2,0,2.2,1,2.2,2.2v13.9
	c0,1.2-1,2.2-2.2,2.2H31.6z"
            />
            <path
              d="M37.7,29.8l-8.2,8.9c-0.5,0.5-0.5,1.3,0,1.9l8.2,8.9c0.5,0.6,1.5,0.6,2,0l8.2-8.9c0.5-0.5,0.5-1.3,0-1.9
	l-8.2-8.9C39.2,29.2,38.3,29.2,37.7,29.8z"
            />
            <circle cx="13" cy="39.4" r="9.3" />
            <path
              d="M4.8,6.5l7.2-4.1c0.7-0.4,1.5-0.4,2.1,0l7.1,4.1c0.7,0.4,1.1,1.1,1.1,1.9v8.2c0,0.8-0.4,1.5-1.1,1.9
	l-7.1,4.1c-0.7,0.4-1.5,0.4-2.1,0l-7.2-4.1c-0.7-0.4-1.1-1.1-1.1-1.9V8.4C3.7,7.6,4.1,6.9,4.8,6.5z"
            />
          </svg>
        </Link>
      </li>
      <li>
        <Link
          to="/"
          onClick={() => {
            onSelect("region/africa");
          }}
          type="button"
          className="inline-flex items-center gap-3 px-1 py-1 text-sm font-medium text-center text-gray-900 rounded-lg bg-translate hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-100 lg:px-3 lg:py-3 dark:focus:ring-gray-600 dark:text-white dark:hover:bg-gray-700"
        >
          <svg
            version="1.1"
            id="Layer_1"
            x="0px"
            y="0px"
            fill="#ea8763"
            width="25px"
            height="25px"
            viewBox="0 0 260 259"
            enableBackground="new 0 0 260 259"
          >
            <polygon
              points="256.64,73.218 245.26,70.737 227.247,56.851 198.115,54.537 194.251,47.498 171.156,39.172 159.257,38.146 
	161.421,29.724 157.58,25.406 150.542,8.037 142.669,21.827 119.891,23.615 100.964,28.722 94.165,19.536 97.338,11.33 
	92.877,2.406 87.533,7.345 66.275,13.286 71.619,22.447 53.153,32.492 45.326,23.235 28.554,25.716 27.075,38.29 31.584,45.542 
	27.081,63.861 8.657,73.218 7.536,82.356 2,90.348 14.836,106.906 24.976,103.327 25.381,113.277 40.674,112.25 51.124,104.592 
	59.929,103.661 59.665,112.632 66.49,121.149 90.563,128.402 92.805,130.502 94.88,145.652 105.545,145.771 110.436,154.981 
	109.458,183.539 122.508,185.138 125.562,196.112 132.577,196.566 135.01,217.179 122.938,225.864 117.737,236.862 141.762,256.594 
	144.243,247.503 158.964,231.948 166.05,222.5 166.503,210.021 176.738,199.285 190.72,193.751 207.229,192.271 214.482,186.044 
	214.864,181.511 223.716,169.582 230.921,145.723 230.921,128.76 235.74,126.088 258,99.533 "
            />
          </svg>
        </Link>
      </li>
      <li>
        <Link
          to="/"
          onClick={() => {
            onSelect("region/asia");
          }}
          type="button"
          className="inline-flex items-center gap-3 px-1 py-1 text-sm font-medium text-center text-gray-900 rounded-lg bg-translate hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-100 lg:px-3 lg:py-3 dark:focus:ring-gray-600 dark:text-white dark:hover:bg-gray-700"
        >
          <svg
            version="1.1"
            id="Layer_1"
            x="0px"
            y="0px"
            fill="#75d084"
            width="25px"
            height="25px"
            viewBox="0 0 260 259"
            enableBackground="new 0 0 260 259"
          >
            <polygon
              points="256.64,73.218 245.26,70.737 227.247,56.851 198.115,54.537 194.251,47.498 171.156,39.172 159.257,38.146 
	161.421,29.724 157.58,25.406 150.542,8.037 142.669,21.827 119.891,23.615 100.964,28.722 94.165,19.536 97.338,11.33 
	92.877,2.406 87.533,7.345 66.275,13.286 71.619,22.447 53.153,32.492 45.326,23.235 28.554,25.716 27.075,38.29 31.584,45.542 
	27.081,63.861 8.657,73.218 7.536,82.356 2,90.348 14.836,106.906 24.976,103.327 25.381,113.277 40.674,112.25 51.124,104.592 
	59.929,103.661 59.665,112.632 66.49,121.149 90.563,128.402 92.805,130.502 94.88,145.652 105.545,145.771 110.436,154.981 
	109.458,183.539 122.508,185.138 125.562,196.112 132.577,196.566 135.01,217.179 122.938,225.864 117.737,236.862 141.762,256.594 
	144.243,247.503 158.964,231.948 166.05,222.5 166.503,210.021 176.738,199.285 190.72,193.751 207.229,192.271 214.482,186.044 
	214.864,181.511 223.716,169.582 230.921,145.723 230.921,128.76 235.74,126.088 258,99.533 "
            />
          </svg>
        </Link>
      </li>
      <li>
        <Link
          to="/"
          onClick={() => {
            onSelect("region/europe");
          }}
          type="button"
          className="inline-flex items-center gap-3 px-1 py-1 text-sm font-medium text-center text-gray-900 rounded-lg bg-translate hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-100 lg:px-3 lg:py-3 dark:focus:ring-gray-600 dark:text-white dark:hover:bg-gray-700"
        >
          <svg
            version="1.1"
            id="Layer_1"
            x="0px"
            y="0px"
            fill="#60c2e6"
            width="25px"
            height="25px"
            viewBox="0 0 260 259"
            enableBackground="new 0 0 260 259"
          >
            <polygon
              points="256.64,73.218 245.26,70.737 227.247,56.851 198.115,54.537 194.251,47.498 171.156,39.172 159.257,38.146 
	161.421,29.724 157.58,25.406 150.542,8.037 142.669,21.827 119.891,23.615 100.964,28.722 94.165,19.536 97.338,11.33 
	92.877,2.406 87.533,7.345 66.275,13.286 71.619,22.447 53.153,32.492 45.326,23.235 28.554,25.716 27.075,38.29 31.584,45.542 
	27.081,63.861 8.657,73.218 7.536,82.356 2,90.348 14.836,106.906 24.976,103.327 25.381,113.277 40.674,112.25 51.124,104.592 
	59.929,103.661 59.665,112.632 66.49,121.149 90.563,128.402 92.805,130.502 94.88,145.652 105.545,145.771 110.436,154.981 
	109.458,183.539 122.508,185.138 125.562,196.112 132.577,196.566 135.01,217.179 122.938,225.864 117.737,236.862 141.762,256.594 
	144.243,247.503 158.964,231.948 166.05,222.5 166.503,210.021 176.738,199.285 190.72,193.751 207.229,192.271 214.482,186.044 
	214.864,181.511 223.716,169.582 230.921,145.723 230.921,128.76 235.74,126.088 258,99.533 "
            />
          </svg>
        </Link>
      </li>
      <li>
        <Link
          to="/"
          onClick={() => {
            onSelect("region/oceania");
          }}
          type="button"
          className="inline-flex items-center gap-3 px-1 py-1 text-sm font-medium text-center text-gray-900 rounded-lg bg-translate hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-100 lg:px-3 lg:py-3 dark:focus:ring-gray-600 dark:text-white dark:hover:bg-gray-700"
        >
          <svg
            version="1.1"
            id="Layer_1"
            x="0px"
            y="0px"
            fill="#e3567d"
            width="25px"
            height="25px"
            viewBox="0 0 260 259"
            enableBackground="new 0 0 260 259"
          >
            <polygon
              points="256.64,73.218 245.26,70.737 227.247,56.851 198.115,54.537 194.251,47.498 171.156,39.172 159.257,38.146 
	161.421,29.724 157.58,25.406 150.542,8.037 142.669,21.827 119.891,23.615 100.964,28.722 94.165,19.536 97.338,11.33 
	92.877,2.406 87.533,7.345 66.275,13.286 71.619,22.447 53.153,32.492 45.326,23.235 28.554,25.716 27.075,38.29 31.584,45.542 
	27.081,63.861 8.657,73.218 7.536,82.356 2,90.348 14.836,106.906 24.976,103.327 25.381,113.277 40.674,112.25 51.124,104.592 
	59.929,103.661 59.665,112.632 66.49,121.149 90.563,128.402 92.805,130.502 94.88,145.652 105.545,145.771 110.436,154.981 
	109.458,183.539 122.508,185.138 125.562,196.112 132.577,196.566 135.01,217.179 122.938,225.864 117.737,236.862 141.762,256.594 
	144.243,247.503 158.964,231.948 166.05,222.5 166.503,210.021 176.738,199.285 190.72,193.751 207.229,192.271 214.482,186.044 
	214.864,181.511 223.716,169.582 230.921,145.723 230.921,128.76 235.74,126.088 258,99.533 "
            />
          </svg>
        </Link>
      </li>
      <li>
        <Link
          to="/"
          onClick={() => {
            onSelect("region/america");
          }}
          type="button"
          className="inline-flex items-center gap-3 px-1 py-1 text-sm font-medium text-center text-gray-900 rounded-lg bg-translate hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-100 lg:px-3 lg:py-3 dark:focus:ring-gray-600 dark:text-white dark:hover:bg-gray-700"
        >
          <svg
            version="1.1"
            id="Layer_1"
            x="0px"
            y="0px"
            fill="#f1c75b"
            width="25px"
            height="25px"
            viewBox="0 0 260 259"
            enableBackground="new 0 0 260 259"
          >
            <polygon
              points="256.64,73.218 245.26,70.737 227.247,56.851 198.115,54.537 194.251,47.498 171.156,39.172 159.257,38.146 
	161.421,29.724 157.58,25.406 150.542,8.037 142.669,21.827 119.891,23.615 100.964,28.722 94.165,19.536 97.338,11.33 
	92.877,2.406 87.533,7.345 66.275,13.286 71.619,22.447 53.153,32.492 45.326,23.235 28.554,25.716 27.075,38.29 31.584,45.542 
	27.081,63.861 8.657,73.218 7.536,82.356 2,90.348 14.836,106.906 24.976,103.327 25.381,113.277 40.674,112.25 51.124,104.592 
	59.929,103.661 59.665,112.632 66.49,121.149 90.563,128.402 92.805,130.502 94.88,145.652 105.545,145.771 110.436,154.981 
	109.458,183.539 122.508,185.138 125.562,196.112 132.577,196.566 135.01,217.179 122.938,225.864 117.737,236.862 141.762,256.594 
	144.243,247.503 158.964,231.948 166.05,222.5 166.503,210.021 176.738,199.285 190.72,193.751 207.229,192.271 214.482,186.044 
	214.864,181.511 223.716,169.582 230.921,145.723 230.921,128.76 235.74,126.088 258,99.533 "
            />
          </svg>
        </Link>
      </li>
    </ul>
  );
}

export default Search;
